export default class ChatWidgetHelper {
  static show() {
    window?.Bizzey?.showLauncher();
  }

  static hide() {
    window.Bizzey?.hideLauncher();
  }

  static openChat() {
    window?.Bizzey?.open();
  }
}